import { createAction, createPayloadAction } from '../../../core/helpers'

import { FETCH_INGREDIENT, SET_INGREDIENT_PAGE_TO_DIRTY } from '../action-types'

export const cleanupFetchIngredient = createAction(FETCH_INGREDIENT.CLEANUP)

export const setIngredientPageIsDirty = createPayloadAction(
  SET_INGREDIENT_PAGE_TO_DIRTY,
)
